export default {
  pageTitle: 'Products',
  metaDescription: 'Browse TEF\'s fabricated products: pressure vessels, heat exchangers, piping, towers, muffles, radiant tubes and other industrial equipment in special materials.',
  fabricationOf: 'Fabrication of',
  categories: {
    vessel: 'Vessel',
    heatExchanger: 'Heat Exchanger',
    piping: 'Piping',
    tower: 'Tower',
    radiantTube: 'Radiant Tube',
    muffle: 'Muffle',
    otherEquipment: 'Other Equipment',
  },
  onSiteServices: {
    heading: 'ON SITE SERVICES',
    items: {
      weldingOverlay: 'Welding Overlay',
      patching: 'Patching',
      piping: 'Piping',
      reShell: 'Re-Shell',
      reTubing: 'Re-Tubing',
      shutdownMaintenance: 'Shutdown Maintenance',
    },
  },
};
